/*
 * Copyright (c) 2023 CalAmp Corp. All Rights Reserved
 */

/**
 * @normalizeVideoLink
 *
 * This helper function normalizes a video link by replacing a specified part of the URL with a replacement string.
 *
 * @param {object} event - The event object containing the video link.
 * @param {string} current - The current part of the video link that needs to be replaced.
 * Defaults to 'qaapi.lojack.com'.
 * @param {string} replacement - The replacement string to be used in place of the current part of the video link.
 * Defaults to 'qa.connect.calamp.com/api'.
 * @returns {string} - The normalized video link with the specified part replaced by the replacement string.
 */
export const normalizeVideoLink = (
  event,
  current = 'qaapi.lojack.com',
  replacement = 'qa.connect.calamp.com/api'
): string => {
  return event?.videoLink?.replace(current, replacement);
};
